import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDialog,{attrs:{"persistent":"","max-width":"400px"},model:{value:(_vm.mostrar),callback:function ($$v) {_vm.mostrar=$$v},expression:"mostrar"}},[_c(VCard,[_c(VCardTitle,{staticClass:"headline"},[_vm._v(_vm._s(_vm.titulo))]),_c(VCardText,{domProps:{"innerHTML":_vm._s(_vm.texto)}}),_c(VCardActions,[_c(VSpacer),_c(VBtn,{attrs:{"small":"","outlined":""},on:{"click":function($event){return _vm.$emit('cancelar')}}},[_vm._v("Cancelar")]),_c(VBtn,{attrs:{"small":"","dark":"","color":"blue-grey"},on:{"click":function($event){return _vm.$emit('aceptar')}}},[_vm._v("Aceptar")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }